/**
 * Регистрирует SVG-щит как SDF-image в Mapbox.
 * SDF (Signed Distance Field) позволяет перекрашивать иконку через icon-color.
 *
 * @param {mapboxgl.Map} map
 */
export const registerShieldImage = map => {
    const size = 48;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    const scale = size / 24;
    ctx.scale(scale, scale);

    // Рисуем путь щита из SVG: M 12 23 L 20 18 V 5 L 4 5 L 4 18 L 12 23 Z
    ctx.beginPath();
    ctx.moveTo(12, 23);
    ctx.lineTo(20, 18);
    ctx.lineTo(20, 5);
    ctx.lineTo(4, 5);
    ctx.lineTo(4, 18);
    ctx.lineTo(12, 23);
    ctx.closePath();

    // Заливаем белым — SDF использует яркость для маски, белый = непрозрачно
    ctx.fillStyle = '#ffffff';
    ctx.fill();
    // Обводка (stroke-width=2 в координатах viewBox, масштабируется вместе с fill)
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 2;
    ctx.lineJoin = 'round';
    ctx.stroke();

    const url = canvas.toDataURL('image/png');

    map.loadImage(url, (error, image) => {
        if (error) {
            console.error('[ShieldImage] Failed to load:', error);
            return;
        }
        if (!map.hasImage('shield-icon')) {
            // sdf: true — разрешает перекраску через icon-color в paint
            map.addImage('shield-icon', image, { sdf: true });
        }
    });
};
